import { render, staticRenderFns } from "./UpgradeForTranslationBanner.vue?vue&type=template&id=53e6d102&scoped=true&"
import script from "./UpgradeForTranslationBanner.vue?vue&type=script&lang=js&"
export * from "./UpgradeForTranslationBanner.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeForTranslationBanner.vue?vue&type=style&index=0&id=53e6d102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6d102",
  null
  
)

export default component.exports